import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(url && key);
if (!supabaseConfigured) console.error("Sign-in is not configured: set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in frontend/.env");

// Email links carry a token_hash (verified in AuthCallback / ResetPassword) so they work on any device;
// Google returns a ?code that AuthCallback exchanges. Nothing is detected from the URL automatically.
export const supabase = createClient(url || "http://localhost:54321", key || "not-configured", {
  auth: { flowType: "pkce", persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
});

export const authRedirect = (path) => `${window.location.origin}${path}`;

const MESSAGES = {
  invalid_credentials: "Email or password is incorrect.",
  email_not_confirmed: "Confirm your email first — we sent you a link.",
  user_already_exists: "An account with this email already exists. Sign in instead.",
  weak_password: "Choose a stronger password (8+ characters).",
  over_email_send_rate_limit: "Too many emails sent. Wait a minute and try again.",
  over_request_rate_limit: "Too many attempts. Try again in a few minutes.",
  otp_expired: "That link has expired or was already used. Request a new one.",
  same_password: "Choose a password you haven't used before.",
};

export const authErrorText = (error) => MESSAGES[error?.code] || error?.message || "Something went wrong. Please try again.";
